import React from "react";
import { Card, Descriptions, PageHeader, Button } from "antd";
import moment from "moment";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export const ViewVoterData = (props) => {
  const handleDownloadPDF = () => {
    const element = document.getElementById("view-profile");
    html2canvas(element, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save("VoterDetails.pdf");
    });
  };
  console.log("props", props);

  return (
    <div id="view-profile">
      <div style={{ padding: "20px 0" }}>
        <PageHeader
          onBack={false}
          title="Voter Details"
          extra={[
            <Button type="primary" onClick={handleDownloadPDF}>
              Download PDF
            </Button>,
          ]}
        >
          <Card className="viewCard">
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Voter Id</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.epic_no
                    ? props?.data?.epic_no
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading"> Name</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.name ? props?.data?.name : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">DOB</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.dob
                    ? moment(props?.data?.dob).format("DD/MM/YYYY")
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={
                  <span className="sub-heading">Assembly Constituency</span>
                }
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.assembly_constituency
                    ? props?.data?.assembly_constituency
                    : ""}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Part Name</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.part_name
                    ? props?.data?.part_name
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">State</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.state ? props?.data?.state : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Parliamentary Name</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.parliamentary_name
                    ? props?.data?.parliamentary_name
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={
                  <span className="sub-heading">Parliamentary Number</span>
                }
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.parliamentary_number
                    ? props?.data?.parliamentary_number
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={
                  <span className="sub-heading">
                    Parliamentary Constituency
                  </span>
                }
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.parliamentary_constituency
                    ? props?.data?.parliamentary_constituency
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Age</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.age ? props?.data?.age : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Area</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.area ? props?.data?.area : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={
                  <span className="sub-heading">
                    Assembly Constituency Number
                  </span>
                }
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.assembly_constituency_number
                    ? props?.data?.assembly_constituency_number
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">District</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.district
                    ? props?.data?.district
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Gender</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.gender
                    ? props?.data?.gender == "F"
                      ? "Female"
                      : "Male"
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Multiple</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.multiple
                    ? props?.data?.multiple
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Name v1</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.name_v1
                    ? props?.data?.name_v1
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Name v2</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.name_v2
                    ? props?.data?.name_v2
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Name v3</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.name_v3
                    ? props?.data?.name_v3
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Part Number</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.part_number
                    ? props?.data?.part_number
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Polling Station</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.polling_station
                    ? props?.data?.polling_station
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Relation Name</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.relation_name
                    ? props?.data?.relation_name
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Relation Type</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.relation_type
                    ? props?.data?.relation_type
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Rln Name v1</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.rln_name_v1
                    ? props?.data?.rln_name_v1
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Rln Name v2</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.rln_name_v2
                    ? props?.data?.rln_name_v2
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Rln Name v3</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.rln_name_v3
                    ? props?.data?.rln_name_v3
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Section No</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.section_no
                    ? props?.data?.section_no
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Slno Inpart</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.slno_inpart
                    ? props?.data?.slno_inpart
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">St Code</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.st_code
                    ? props?.data?.st_code
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Reason</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.type ? props?.data?.type : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Details</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.details
                    ? props?.data?.details
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
          </Card>
        </PageHeader>
      </div>
    </div>
  );
};
